import { store } from '@/state/store';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';

export class UTILS__graph_ui {
  /*
   *
   */

  static node__select(node_id: string) {
    this.edge__select_raw(ENUM__string_id_empty.UUID);

    this.node__select_raw(node_id);
  }

  private static node__select_raw(node_id: string) {
    store.dispatch(LOCAL__ui_set_string({ key: 'g_graph__node_id_selected', value: node_id, valid_values: [] }));
  }

  static node__deselect() {
    this.node__select(ENUM__string_id_empty.UUID);
  }

  /*
   *
   */

  static edge__select(edge_id: string) {
    this.node__select_raw(ENUM__string_id_empty.UUID);

    this.edge__select_raw(edge_id);
  }

  private static edge__select_raw(edge_id: string) {
    store.dispatch(LOCAL__ui_set_string({ key: 'g_graph__edge_id_selected', value: edge_id, valid_values: [] }));
  }

  static edge__deselect() {
    this.edge__select(ENUM__string_id_empty.UUID);
  }
}
